import { combineReducers } from 'redux'
import portal from './portal'
import info from './info'
import auth from './auth'
import modalReducer from '../modules/redux-modal/redux/modalReducer'
import listing from './listing'
import banners from './banners'
import town from './town'
import contributor from './contributor';

export default combineReducers({
  town: town,
  banners: banners,
  auth: auth,
  portal: portal,
  info: info,
  modal: modalReducer,
  listing: listing,
  contributor: contributor,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js